import axios from 'axios';
import { baseUrl } from 'config';
import axiosInstance from '../../utils/https';
import {
    ALL_FRAUDGUARDIAN_LIST,
    ALL_RESPONSES,
    ALL_VENDORS,
    ONE_VENDOR,
    ONE_VENDOR_UPLOADED_QUESTIONNAIRE,
    QUESTIONNAIRE_DETAILS,
    QUESTIONNAIRE_FORMS,
    QUESTIONNAIRE_HISTORY,
    VENDOR_RESPONSES,
    VENDOR_UPLOADED_QUESTIONNAIRE,
} from '../constants';

// merchant
export const GetAllVendors = () => async (dispatch, getState) => {
    const company_id = getState().authReducers?.company_id;
    const needsID = getState().authReducers?.user_type === 'admin' || getState().authReducers?.user_type === 'auditor';
    try {
        const res = needsID
            ? await axiosInstance().get(`/compliance/vendor/?merchant=${company_id}`)
            : await axiosInstance().get(`/compliance/vendor/`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: ALL_VENDORS, payload: res?.data });
        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const DeleteQuestionnaire = (id, vendorId) => async (dispatch) => {
    try {
        const res = await axiosInstance().delete(`/compliance/questionnaire_history/${id}`);

        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);

        dispatch(GetQuestionnaireHistory(vendorId));
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const GetQuestionnaireHistory = (id, params) => async (dispatch) => {
    try {
        const res = await axiosInstance().get(`/compliance/questionnaire_history/?vendor=${id}`, {
            params,
        });

        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.data?.message);

        dispatch({
            type: QUESTIONNAIRE_HISTORY,
            payload: res?.data,
        });
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const GetVendorQuestionnaireDetails = (params) => async (dispatch) => {
    try {
        const res = await axios.get(`${baseUrl}/compliance/questionnaire_history/`, {
            params,
        });

        if (res?.data?.status?.toLowerCase() !== 'success') throw new Error(res?.data?.message);

        dispatch({
            type: QUESTIONNAIRE_DETAILS,
            payload: res?.data?.data?.[0],
        });
        return {
            success: true,
            message: res?.data?.message,
            data: res?.data?.data?.[0],
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const UpdateQuestionnaireHistory =
    (token, id, body, reload = true) =>
    async (dispatch) => {
        try {
            const res = await axiosInstance().patch(`/compliance/questionnaire_history/${id}/?token=${token}`, body, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);

            if (reload) dispatch(GetVendorQuestionnaireDetails({ token }));
            return {
                success: true,
                message: res?.message,
            };
        } catch (err) {
            return { success: false, message: err.message };
        }
    };

export const GetFilteredVendors = (page, params) => async (dispatch, getState) => {
    const company_id = getState().authReducers?.company_id;
    const needsID = getState().authReducers?.user_type === 'admin' || getState().authReducers?.user_type === 'auditor';
    try {
        const res = needsID
            ? await axiosInstance().get(`/compliance/vendor/?merchant=${company_id}&page=${page}`, {
                  params,
              })
            : await axiosInstance().get(`/compliance/vendor/?page=${page}`, { params });

        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);

        dispatch({
            type: ALL_VENDORS,
            payload: res?.data,
        });
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const AddVendor = (credentials) => async (dispatch, getState) => {
    const merchant = getState().authReducers?.company_id;
    try {
        const res = await axiosInstance().post(`/compliance/vendor/`, { ...credentials, merchant });
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err?.message };
    }
};

export const UploadResponse = (credentials) => async (dispatch, getState) => {
    const merchant = getState().authReducers?.company_id;
    credentials.append('merchant_id', merchant);
    try {
        const res = await axiosInstance().post(`/compliance/vendor_questionnaire_upload/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetAllVendors());
        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err?.message };
    }
};
export const UploadBulkVendors = (credentials) => async (dispatch, getState) => {
    const merchant = getState().authReducers?.company_id;
    credentials.append('merchant', merchant);
    try {
        const res = await axiosInstance().post(`/compliance/vendor_upload/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetAllVendors());
        return {
            success: true,
            message: 'You have successfully invited this vendor! They will get a mail in few minutes.',
        };
    } catch (err) {
        return { success: false, message: err?.message };
    }
};

export const EditVendor = (credentials, id) => async () => {
    try {
        const res = await axiosInstance().patch(`/compliance/vendor/${id}/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err?.message };
    }
};

export const ResendQuestionnaire =
    (credentials, reload = true) =>
    async (dispatch) => {
        try {
            const res = await axiosInstance().post(`/compliance/resend_questionnaire/`, credentials);
            if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
            reload && dispatch(GetAllVendors());
            return {
                success: true,
                message: res.message,
            };
        } catch (err) {
            return { success: false, message: err?.message };
        }
    };
export const DeleteVendor = (id) => async (dispatch) => {
    try {
        const res = await axiosInstance().delete(`/compliance/vendor/${id}/`);
        console.log(res);
        dispatch(GetAllVendors());
        return {
            success: true,
            message: 'Vendor deleted successfully.',
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

// reponses
export const GetAllResponses = () => async (dispatch, getState) => {
    const company_id = getState().authReducers?.company_id;
    const needsID = getState().authReducers?.user_type === 'admin' || getState().authReducers?.user_type === 'auditor';
    try {
        const res = needsID
            ? await axiosInstance().get(`/compliance/user_vendor_forms/?merchant=${company_id}`)
            : await axiosInstance().get(`/compliance/user_vendor_forms/`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: ALL_RESPONSES, payload: res?.data });
        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
// vendors view
export const GetOneVendor = (id, params) => async (dispatch) => {
    try {
        const res = await axiosInstance().get(`/compliance/vendor/${id}/`, {
            ...(params && { params }),
        });
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: ONE_VENDOR, payload: res?.data });
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const UpdateVendorDetails =
    (body, id, reload = true, params) =>
    async (dispatch) => {
        try {
            const res = await axiosInstance().patch(`/compliance/vendor/${id}/`, body, {
                headers: { 'Content-Type': 'multipart/form-data' },
                ...(params && { params }),
            });
            if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
            dispatch(GetOneVendor(id, params));
            if (reload) {
                dispatch(GetAllResponses());
            }

            return {
                success: true,
                message: res?.message,
            };
        } catch (err) {
            return { success: false, message: err.message };
        }
    };
export const GetVendorResponses = (vendor_id, params) => async (dispatch) => {
    try {
        const res = await axiosInstance().get(`/compliance/user_vendor_forms/?vendor=${vendor_id}`, {
            params,
        });
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: VENDOR_RESPONSES, payload: res?.data });
        return {
            success: true,
            message: res?.message,
            data: res?.data,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const CreateVendorResponse = (body, params) => async (dispatch) => {
    try {
        const res = await axiosInstance().post(`/compliance/user_vendor_forms/`, body, {
            ...(params && { params }),
        });

        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(
            GetVendorResponses(body?.vendor, {
                vendor_questionnaire: body?.vendor_questionnaire,
                ...(params || {}),
            })
        );

        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const EditVendorResponse = (body, response_id, token) => async (dispatch) => {
    try {
        const res = await axiosInstance().patch(
            `/compliance/user_vendor_forms/${response_id}/`,
            {
                answer: body.answer,
                vendor_questionnaire: body.vendor_questionnaire,
            },
            {
                ...(token && {
                    params: {
                        token,
                    },
                }),
            }
        );

        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);

        dispatch(
            GetVendorResponses(body.vendor, {
                vendor_questionnaire: body?.vendor_questionnaire,
                ...(token && { token }), // pass token here too if needed
            })
        );

        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const GetQuestionnaireForms =
    (isNonAml = false, token) =>
    async (dispatch) => {
        try {
            const res = await axiosInstance().get(`/compliance/vendor_forms/`, {
                params: {
                    ...(isNonAml && { title: 'Anti-Money Laundering' }),
                    ...(token && { token }),
                },
            });

            if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);

            dispatch({ type: QUESTIONNAIRE_FORMS, payload: res?.data });

            return {
                success: true,
                message: res?.message,
            };
        } catch (err) {
            return { success: false, message: err.message };
        }
    };

export const CreateQuestonnaireForm = (credentials) => async (dispatch) => {
    try {
        const res = await axiosInstance().post(`/compliance/vendor_forms/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetQuestionnaireForms());
        return {
            success: true,
            message: res.message,
            form_id: res?.data?.id,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const EditQuestonnaireForm = (credentials, id) => async (dispatch) => {
    try {
        const res = await axiosInstance().patch(`/compliance/vendor_forms/${id}/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetQuestionnaireForms());
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const DeleteQuestonnaireForm = (id) => async (dispatch) => {
    try {
        const res = await axiosInstance.delete(`/compliance/vendor_forms/${id}/`);
        console.log(res);
        dispatch(GetQuestionnaireForms());
        return {
            success: true,
            message: 'You have deleted this section successfully.',
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const CreateFormField = (credentials) => async (dispatch) => {
    try {
        const res = await axiosInstance().post(`/compliance/vendor_form_fields/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetQuestionnaireForms());
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const EditFormField = (id, credentials) => async (dispatch) => {
    try {
        const res = await axiosInstance().patch(`/compliance/vendor_form_fields/${id}/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetQuestionnaireForms());
        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const DeleteFormField = (id) => async (dispatch) => {
    try {
        const res = await axiosInstance().delete(`/compliance/vendor_form_fields/${id}/`);
        console.log(res);
        dispatch(GetQuestionnaireForms());
        return {
            success: true,
            message: 'Field deleted successfully.',
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

// file upload
export const UploadFile = (formData) => async () => {
    try {
        const res = await axiosInstance().post(`/compliance/vendor_file_upload/`, formData);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        return {
            success: true,
            message: res.message,
            file_url: res.data,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

// AI Vendor Responder
export const GetAllUploadedVendorQuestionnaire = () => async (dispatch) => {
    try {
        const res = await axiosInstance().get(`/compliance/questionnaire_predictions/`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: VENDOR_UPLOADED_QUESTIONNAIRE, payload: res?.data });
        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const GetOneUploadedVendorQuestionnareDetails = (id) => async (dispatch) => {
    try {
        const res = await axiosInstance().get(`/compliance/questionnaire_predictions/${id}/`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: ONE_VENDOR_UPLOADED_QUESTIONNAIRE, payload: res?.data });
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const UploadVendorQuestionnaire = (formData) => async (dispatch, getState) => {
    const merchant_id = getState().authReducers?.company_id;
    // const user_id = getState()?.authReducers?.user_id;
    formData.append('merchant', merchant_id);
    try {
        const res = await axiosInstance().post(`/compliance/questionnaire_upload/`, formData);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        setTimeout(() => dispatch(GetAllUploadedVendorQuestionnaire()), 7000);
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        console.log({ err });
        return { success: false, message: err?.message };
    }
};

export const DeleteUploadedVendorQuestionnaire = (id) => async (dispatch) => {
    try {
        const res = await axiosInstance().delete(`/compliance/questionnaire_predictions/${id}/`);
        console.log(res);
        dispatch(GetAllUploadedVendorQuestionnaire());
        return {
            success: true,
            message: 'Vendor Questionnaire deleted successfully.',
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};
export const SaveApprovedQuestionnaireAnswers = (id, credentials) => async (dispatch) => {
    try {
        const res = await axiosInstance().patch(`/compliance/questionnaire_predictions/${id}/`, credentials);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch(GetAllUploadedVendorQuestionnaire());
        dispatch(GetOneUploadedVendorQuestionnareDetails(id));
        return {
            success: true,
            message: res?.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const GetAllFraudGuardianList = () => async (dispatch) => {
    try {
        const res = await axiosInstance().get(`/v1/fraudguardian/type_list/`);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        dispatch({ type: ALL_FRAUDGUARDIAN_LIST, payload: res?.data });
        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const AddInAppSearch = (credentials) => async (_, getState) => {
    const merchant = getState().authReducers?.company_id;
    const body = {
        ...credentials,
        merchant,
    };
    try {
        const res = await axiosInstance().post(`/v1/fraudguardian/in_app_search/`, body);
        if (res?.status?.toLowerCase() !== 'success') throw new Error(res?.message);
        return {
            success: true,
            message: res.message,
        };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

export const RequestQuestionnaire = async ({ data }) => {
    const res = await axios.post(`${baseUrl}/compliance/expired_vendor/`, data);
    return res.data;
};
